<template>
    <div class="posts-wrapper">
        <i-paginator v-if="paginate" :page="page" :records="total" :perPage="12" @input="(page)=>{setPage(page)}" />
        <div class="container">
            <div class="posts row">
                <div class="post col-sm-6 col-md-4" v-for="(post,index) in posts.slice(perPage*(page-1),perPage*page)" :key="index" @click="openPost(post)">
                    <!-- {{index}} -->
                    <div class="preview" :style="{backgroundImage:`url(${post.preview || 'http://content.iwep.kz/default-image.png'}?w=350)`}">
                        <img src="data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAABCAQAAABeK7cBAAAAC0lEQVR42mNkAAIAAAoAAv/lxKUAAAAASUVORK5CYII=" alt="" class="stretch">
            </div>
                        <h3>{{post.content[lang].title}}</h3>
                        <p class='short'>{{post.content[lang].short | short(120)}}</p>
                        <hr>
                        <span class="date number">{{post.date | date("D")}}</span>
                        <div class="author" v-for="(author,idx) in post.authors"  :key="idx">
                            <div class="avatar" :style="{backgroundImage:`url(${author.image})`}">
                                <img class="stretch" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7">
              </div>
                                <div class="name">{{author.name}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <i-paginator v-if="paginate" :page="page" :records="total" :perPage="12" @input="(page)=>{setPage(page)}" />
            </div>
</template>
<script>
//import posts from "../assets/json/posts.json";
//import experts from "../assets/json/experts.json";
import iPaginator from "../components/i-paginator"
export default {
    name: 'post-grid',
    props: {
        paginate: { type: Boolean, default: true },
        posts: { type: Array, default () { return [] } },
        total: { type: Number, default: 0 },
    },
    components: {iPaginator},
    data() {
        return {
            page: 1,
            perPage: 12
        }
    },
    methods: {
        openPost(post) {
            //this.$store.commit('viewPost',post);
            location.href = "#/posts/" + post._id + '/#header';
        },
        setPage(page) {
            console.log("!!!", page);
            this.page = page;
            //this.$route.query.page = page;
            this.$router.push({ query: { page } })
            //document.documentElement.scrollTop=0;
            //this.$store.dispatch('loadPosts', (page-1)*9);
        }
    },
    mounted() {
        let { page } = this.$route.query;
        if (page) this.setPage(parseInt(page));
    },
    computed: {
        //posts(){return this.$store.state.posts.list;},
        //total(){return this.$store.state.posts.total;},
        lang() { return this.$store.state.lang; },
        tr() { return this.$store.getters.translates; }
    }
}
</script>
<style lang="css" scoped>
.posts-wrapper h2 {
    font-weight: normal;
    padding: 0 10px;
    text-align: center;
    /*border-left:3px solid lightgrey;*/
    /* display: inline-block;*/
    margin-left: 20px;
    text-align: center;
    font-size: 28px;
}

.posts {
    text-align: center;
}

.post {
    /* min-width: 300px;*/
    /*max-width: 300px;*/
    /*border:1px solid lightgrey;*/
    padding: 12px;
    display: inline-block;
    vertical-align: top;
    /*margin:5px;*/
    border-radius: 2px;
    text-align: left;
    line-height: 1.5;
    margin-bottom: 16px;

}

.post:hover {
    background: whitesmoke;
    cursor: pointer;
    /*transform:scale(1.05);*/
    transition: 0.2s all ease;
}

.post h3 {
    font-size: 20px;
    font-weight: normal;
    line-height: 1.2;
}

.post img {
    max-width: 100%;
}

.post .preview {
    background-size: cover;
    background-position: center;
}

.post hr {
    height: 0;
    border: none;
    border-bottom: 1px solid lightgrey;

}

.post .short {
    font-size: 13px;
    text-align: left;
    font-family: 'Merriweather', serif;
    text-align: justify;
}

.post .date {
    font-size: 12px;
    color: grey;
    display: block;
    text-align: right;
}

.post .author .avatar {
    width: 32px;
}

.post .author .name {
    font-size: 12px;
    display: inline-block;
    vertical-align: middle;
}

.paginator {
    text-align: center;
    padding-bottom: 10px;
}
</style>